<template>
  <div>
    <div class="main-layout">
      <router-view v-slot="{ Component }">
        <transition name="van-slide-up">
          <keep-alive v-if="$route.meta.keepAlive">
            <component :is="Component" />
          </keep-alive>
          <component v-else :is="Component" />
        </transition>
      </router-view>
    </div>
    <van-tabbar route :style="tabBar ? 'bottom: -3px;transition:bottom .5s' : 'bottom: -55px;transition:bottom .5s'">
      <van-tabbar-item replace to="/home" icon="send-gift-o">古 籍</van-tabbar-item>
      <van-tabbar-item replace to="/ancient-poetry" icon="orders-o">古诗词</van-tabbar-item>
      <van-tabbar-item replace to="/novel" icon="medal-o">小说 名著</van-tabbar-item>
      <van-tabbar-item replace to="/mine" icon="manager-o">我的</van-tabbar-item>
    </van-tabbar>
  </div>
</template>
<script setup>
import { ref, watch } from 'vue';
import { useRoute } from 'vue-router';
const route = useRoute()
let tabBar = ref(true)
watch(route, (next, _) => {
  tabBar.value = next.meta.tabBar
})
</script>
<style lang="less" scoped>
.main-layout {
  padding-bottom: 50px;
}
</style>